export enum transmittalItemRequestErrorKey {
  DOC_NO = 'docNo',
  REVISION_NO = 'revisionNo',
  DESCRIPTION = 'description',
  PROJECT_FILE = 'projectFile',
}

export const TRANSMITTAL_ITEM_REVISION_NOT_ISSUE_KEY = 'notIssue';

export enum ETransmittalItemTableFormKey {
  docNo = 'item.docNo',
  description = 'item.description',
  revisionNo = 'revisionNo',
  form = 'form',
  lastModifiedDateTime = 'lastModifiedDateTime',
  uuid = 'uuid',
  itemId = 'item.id',
  inUse = 'item.inUse',
  file = 'file',
  projectFile = 'projectFile',
  projectFileUrl = 'projectFile.url',
  projectFileUploadState = 'projectFile.uploadState',
}

export type TTransmittalItemTableFormMobileDetailModalType =
  | 'View'
  | 'CreateItem'
  | 'UpdateItem'
  | 'UpdateRevision'
  | 'UpdateIssuableRevision'
  | 'UpdateApprovalRevision';
